import en from "./en.json";

const resources = {
  en,
};

export default resources;
